import { KarpenterLogoSvg } from '../assets/svg';

type Props = {
  size?: number;
};

export const KarpenterLogo = ({ size = 22 }: Props) => {
  return (
    <KarpenterLogoSvg
      color="#5A60AD"
      height={size}
      width={size}
      style={{ flexShrink: 0 }}
      data-testid="karpenter-logo"
    />
  );
};
